/**
 * Creates a burst of particles at the specified position
 * @param x - X coordinate of the burst
 * @param y - Y coordinate of the burst
 * @param color - Color of the particles
 * @param count - Number of particles to create
 * @param container - The container element to add particles to
 */
export const createParticleBurst = (
  x: number,
  y: number,
  color: string = '#d4a5ff',
  count: number = 20,
  container: HTMLElement = document.body
): void => {
  for (let i = 0; i < count; i++) {
    // Create particle element
    const particle = document.createElement('div');
    particle.style.position = 'absolute';
    particle.style.width = `${Math.random() * 6 + 2}px`;
    particle.style.height = particle.style.width;
    particle.style.backgroundColor = color;
    particle.style.borderRadius = '0';
    particle.style.pointerEvents = 'none';
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.opacity = '1';
    
    // Add to container
    container.appendChild(particle);
    
    // Random angle and distance
    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * 100 + 50;
    const duration = Math.random() * 1000 + 500;
    
    // Animate with requestAnimationFrame for better performance
    const startTime = performance.now();
    
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = elapsed / duration;
      
      if (progress >= 1) {
        particle.remove();
        return;
      }
      
      // Easing function (ease-out)
      const eased = 1 - Math.pow(1 - progress, 2);
      
      // Movement
      const moveX = Math.cos(angle) * distance * eased;
      const moveY = Math.sin(angle) * distance * eased;
      
      // Gravity effect
      const gravity = 100 * (progress * progress);
      
      // Update position
      particle.style.transform = `translate(${moveX}px, ${moveY + gravity}px)`;
      
      // Fade out
      particle.style.opacity = `${1 - progress}`;
      
      requestAnimationFrame(animate);
    };
    
    requestAnimationFrame(animate);
  }
};